import { render } from "./Yakkan.vue?vue&type=template&id=42804d7a&scoped=true"
import script from "./Yakkan.vue?vue&type=script&lang=js"
export * from "./Yakkan.vue?vue&type=script&lang=js"

import "./Yakkan.vue?vue&type=style&index=0&id=42804d7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42804d7a"]])

export default __exports__